
import { User } from "lucide-react";

export const LandingTestimonials = () => {
    return (
        <section className="py-20 bg-white border-y border-gray-100/50">
            <div className="container mx-auto px-4">
                <div className="text-center max-w-3xl mx-auto mb-16">
                    <h2 className="font-heading text-3xl md:text-3xl font-bold text-gray-900 mb-4">
                        Small businesses love RaffleKit.
                    </h2>
                </div>

                <div className="grid md:grid-cols-3 gap-8">
                    <div className="bg-gray-50 p-6 rounded-2xl border border-gray-100">
                        <div className="flex gap-1 text-yellow-500 mb-4">
                            {[1, 2, 3, 4, 5].map(i => <span key={i}>★</span>)}
                        </div>
                        <p className="text-gray-600 mb-6 italic">"Simply the easiest way to run a contest. We collected 500+ emails in our first week."</p>
                        <div className="flex items-center gap-3">
                            <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center">
                                <User className="w-5 h-5 text-gray-500" />
                            </div>
                            <div>
                                <div className="font-bold text-gray-900 text-sm">Sarah Jenkins</div>
                                <div className="text-xs text-gray-500">Cafe Owner</div>
                            </div>
                        </div>
                    </div>

                    <div className="bg-gray-50 p-6 rounded-2xl border border-gray-100">
                        <div className="flex gap-1 text-yellow-500 mb-4">
                            {[1, 2, 3, 4, 5].map(i => <span key={i}>★</span>)}
                        </div>
                        <p className="text-gray-600 mb-6 italic">"No complicated settings. It just works. My customers loved the referral sharing."</p>
                        <div className="flex items-center gap-3">
                            <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center">
                                <User className="w-5 h-5 text-gray-500" />
                            </div>
                            <div>
                                <div className="font-bold text-gray-900 text-sm">Mike Ross</div>
                                <div className="text-xs text-gray-500">Local Gym Owner</div>
                            </div>
                        </div>
                    </div>

                    <div className="bg-gray-50 p-6 rounded-2xl border border-gray-100">
                        <div className="flex gap-1 text-yellow-500 mb-4">
                            {[1, 2, 3, 4, 5].map(i => <span key={i}>★</span>)}
                        </div>
                        <p className="text-gray-600 mb-6 italic">"Finally a tool that doesn't cost an arm and a leg for basic features. Highly recommend."</p>
                        <div className="flex items-center gap-3">
                            <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center">
                                <User className="w-5 h-5 text-gray-500" />
                            </div>
                            <div>
                                <div className="font-bold text-gray-900 text-sm">Elena Rodriguez</div>
                                <div className="text-xs text-gray-500">Handmade Shop</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
